import { Button, Link, Skeleton, Stack, Typography } from '@mui/material';

import isEmpty from 'lodash/isEmpty';

import ExternalLinkIcon from '@/components/Icons/ExternalLinkIcon';
import { links } from '@/localization';
import { useTrainingProjects } from '@/sections/Overview/Training/hooks';

import Training from '../../Training';
import { EmptyState, Section, TrainingAnimationContainer } from '../styled';

function Trainings() {
  const { trainingProjects, loading } = useTrainingProjects(true);

  function getContent() {
    if (loading) {
      return (
        <Stack pt={1}>
          <Skeleton variant="text" width="30%" />
          <Skeleton variant="text" width="70%" />
          <Skeleton variant="text" width="50%" />
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="text" width="50%" />
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="text" width="30%" />
          <Skeleton variant="text" width="40%" />
        </Stack>
      );
    }

    if (isEmpty(trainingProjects)) {
      return (
        <EmptyState gap={8}>
          <Stack gap={3}>
            <Stack gap={1} maxWidth={600}>
              <Typography variant="subtitle1">Start training and fine-tuning on Baseten</Typography>
              <Typography variant="body1" color="text.muted">
                Run reproducible, scalable training jobs with full control over data, code, compute,
                and runtime settings.{' '}
                <Link href={links.basetenDocsTrainingOverview} target="_blank">
                  Learn more
                </Link>
              </Typography>
            </Stack>
            <Button
              variant="outlined"
              href={links.basetenDocsTrainingOverview}
              endIcon={<ExternalLinkIcon />}
              target="_blank"
              sx={{ width: 'fit-content' }}
            >
              Train or fine-tune a model
            </Button>
          </Stack>
          <TrainingAnimationContainer />
        </EmptyState>
      );
    }

    return (
      <Stack gap={4} mt={-3}>
        <Stack mx={-4}>
          <Training minimal />
        </Stack>
      </Stack>
    );
  }

  return (
    <Section>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack gap={1} height={54}>
          <Typography variant="h3">Training projects</Typography>
          {!isEmpty(trainingProjects) && (
            <Typography variant="body1" color="text.muted">
              Run reproducible, scalable training jobs with full control.
            </Typography>
          )}
        </Stack>
      </Stack>
      {getContent()}
    </Section>
  );
}

export default Trainings;
